
export default {
  name: 'ListingSold',
  props: {
    height: {
      type: String,
      default: '48px',
    },
    width: {
      type: String,
      default: '52px',
    },
    fill: {
      type: String,
      default: '#2F3238',
    },
  },
};
